import gql from 'graphql-tag';
import { serviceConfigModel } from './serviceConfigModel';

export const FETCH_CONTRACTS = gql`
  query {
    contracts {
      edges {
        contract {
          contractId
          customerOrgNodeId
          customerOrgNodeName
          service {
            serviceId
            name
            conversationTypes
            consultationTypes

            config {
              ${ serviceConfigModel }
            }

            messagingSettings {
              maxLengthOfProviderMessage
              maxLengthOfCustomerMessage
              openingMessage {
                locale
                message
              }
              submitMessage {
                locale
                message
              }
              completedMessage {
                locale
                message
              }
            }

            filesPrerequisitesConfig {
              enabled
              attributes {
                minimumUploadedFiles
                maximumUploadedFiles
              }
            }
          }
        }
      }
      totalCount
    }
  }
`;
